/* collection-filters.js — instant (no-reload) filter + sort for the Shop page.
 *
 * Reads the chip bar / sort dropdown rendered by templates/collection.liquid
 * and shows/hides + reorders the product cards in the DOM. Every card carries its
 * own data-tags / data-price / data-date (set in snippets/product-card.liquid),
 * so all the work happens in the browser — no fetch, no page reload.
 *
 * Chip semantics: filters operate ONE AT A TIME (like radio buttons). Clicking a
 * chip makes it the only active filter; clicking it again (or clicking "All")
 * clears back to showing every pack.
 */
(function () {
  function initShopFilters(root) {
    var bar = root.querySelector('[data-shop-filters]');
    var grid = root.querySelector('[data-shop-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    if (!cards.length) return;

    var chips = bar ? Array.prototype.slice.call(bar.querySelectorAll('.shop-chip')) : [];
    var sortSelect = bar ? bar.querySelector('[data-shop-sort]') : null;
    var emptyEl = root.querySelector('[data-shop-empty]');
    var resetBtn = root.querySelector('[data-shop-reset]');

    // Snapshot the server render order = "Best selling / featured" order.
    cards.forEach(function (card, i) { card._featuredIndex = i; });

    var activeFilters = []; // empty = show all

    function cardTags(card) {
      return (card.getAttribute('data-tags') || '').split(/\s+/);
    }

    function matchesFilters(card) {
      if (!activeFilters.length) return true;
      var tags = cardTags(card);
      for (var i = 0; i < activeFilters.length; i++) {
        if (tags.indexOf(activeFilters[i]) !== -1) return true; // OR
      }
      return false;
    }

    function compareCards(a, b) {
      var mode = sortSelect ? sortSelect.value : 'featured';
      var pa = parseFloat(a.getAttribute('data-price')) || 0;
      var pb = parseFloat(b.getAttribute('data-price')) || 0;
      var da = parseFloat(a.getAttribute('data-date')) || 0;
      var db = parseFloat(b.getAttribute('data-date')) || 0;
      switch (mode) {
        case 'title-asc': {
          var ta = a.getAttribute('data-title') || '';
          var tb = b.getAttribute('data-title') || '';
          return ta.localeCompare(tb);
        }
        case 'price-asc': return pa - pb;
        case 'price-desc': return pb - pa;
        case 'newest': return db - da;
        default: return a._featuredIndex - b._featuredIndex; // featured
      }
    }

    function apply() {
      // 1) Sort the full set, then re-append in order (visible + hidden alike, so
      //    toggling a filter back on keeps the chosen sort).
      var ordered = cards.slice().sort(compareCards);
      ordered.forEach(function (card) { grid.appendChild(card); });

      // 2) Show/hide by the active filters.
      var visible = 0;
      cards.forEach(function (card) {
        if (matchesFilters(card)) {
          card.hidden = false;
          card.style.display = '';
          visible++;
        } else {
          card.hidden = true;
          card.style.display = 'none';
        }
      });

      // 3) Empty state.
      if (emptyEl) emptyEl.hidden = visible !== 0;
    }

    function setActiveChipStyles() {
      chips.forEach(function (chip) {
        var f = chip.getAttribute('data-filter');
        var on = f === 'all' ? activeFilters.length === 0 : activeFilters.indexOf(f) !== -1;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var f = chip.getAttribute('data-filter');
        // One filter at a time: selecting a chip replaces any current filter;
        // "All" — or re-clicking the active chip — clears back to everything.
        if (f === 'all' || activeFilters.indexOf(f) !== -1) {
          activeFilters = [];
        } else {
          activeFilters = [f];
        }
        setActiveChipStyles();
        apply();
      });
    });

    if (sortSelect) sortSelect.addEventListener('change', apply);

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        activeFilters = [];
        setActiveChipStyles();
        apply();
      });
    }

    setActiveChipStyles();
    apply();
  }

  function boot() {
    document.querySelectorAll('#shop').forEach(function (s) { initShopFilters(s); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
